export default __webpack_public_path__ + "static/media/load_5.7fb65197.gif";